export const occupationNames = state => state.getIn(['occupationNames', 'entities']);
export const occupationNameById = (state, id) => occupationNames(state).get(String(id));
export const occupationNamesByIds = (state, ids) => ids.map(id => occupationNameById(state, id));
